import type { LicenseTier } from '@cdw-ae/common-data';
import type { ChipTone } from '../chip-tone';

/** Chip tone per license tier — a new tier fails the build here. */
const LICENSE_TIER_TONES = {
  Paid: 'ok',
  Trial: 'ok',
  Consulting: 'ok',
  Lapsed: 'warn',
  Free: 'warn',
  Unlicensed: 'error',
} satisfies Record<LicenseTier, ChipTone>;

/** Maps a license tier to a chip tone (null = no tier to show). */
export function licenseTierTone(tier: LicenseTier | null): ChipTone {
  return tier ? LICENSE_TIER_TONES[tier] : 'neutral';
}
